<template>
  <div class="container-fluid">
    <!--Navbar-FeedCategories :categories="this.$store.state.StaticFeeds.items" routeName="static"/-->
    <div class="row">
      <div class="col-6 col-sm-3 col-xl-2 p-0">
        <div class="card text-center">
          <div>
          <img class="img-fluid" src="img/75.jpg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import NavbarFeedCategories from "@/components/Navbars/Navbar.FeedCategories.vue";

export default {
  name: "home",
  components: {
    //NavbarFeedCategories,
  },
  computed: {
    doFirstStart: function() {
      if (!window.localStorage.getItem("FirstStart")) {
        window.localStorage.setItem("FirstStart", true);
        return true;
      } else return false;
    }
  }
};
</script>
